
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Check for the "key card" in local storage
  const token = localStorage.getItem('authToken');

  if (!token) {
    // If no key card, redirect to the login page
    return <Navigate to="/admin/login" />;
  }

  // If there is a key card, show the requested page (the children)
  return children;
};

export default ProtectedRoute;